import { createContext } from "react";
import type { AttachmentsContext } from "./AttachmentsContext";

export const ProviderAttachmentsContext =
  createContext<AttachmentsContext | null>(null);
